import { Entity } from "@hds/entity-lib";

class EventRuntimeEngineServiceInfoEntity extends Entity {
    static DEFAULT_DOCUMENT = {
        events: [],
        items: []
    };
    constructor(entityPersistence, seedData = {}, options = {}) {
        super(entityPersistence, seedData, options);
        this._virtualDataModel.fromJSON({
            ...EventRuntimeEngineServiceInfoEntity.DEFAULT_DOCUMENT,
            ...seedData
        });
    }
    /*****************************************************/
    // START ENTITY DATA MODEL
    /*****************************************************/
    get lastUpdated() {
        return this._virtualDataModel.getProperty('lastUpdated');
    }
    set lastUpdated(newLastUpdated) {
        return this._virtualDataModel.setProperty('lastUpdated', newLastUpdated);
    }
    get events() {
        return this._virtualDataModel.getProperty('events');
    }
    set events(newEvents) {
        return this._virtualDataModel.setProperty('events', newEvents);
    }
    get items() {
        return this._virtualDataModel.getProperty('items');
    }
    set items(newItems) {
        return this._virtualDataModel.setProperty('items', newItems);
    }
    /*****************************************************/
    // END ENTITY DATA MODEL
    // START OVERRIDDEN METHODS
    /*****************************************************/
    clone() { throw new Error('METHOD_NOT_ALLOWED'); }
    /*****************************************************/
    // END OVERRIDDEN METHODS
    /*****************************************************/
}
//META PROPERTIES
Object.defineProperty(EventRuntimeEngineServiceInfoEntity.prototype, '_meta', {
    value: {
        storeName: 'event-runtime',
        entityName: 'event-runtime-engine-service-info'
    }
}, { enumerable: false, configurable: false, writable: false, value: "static" });

export { EventRuntimeEngineServiceInfoEntity };
export default EventRuntimeEngineServiceInfoEntity;